import React, { useState } from "react"
import { useNavigate } from "react-router"
import {
  Card,
  Button,
  Typography,
  Divider,
  List,
  Row,
  Col,
  Modal,
  theme,
} from "antd"

import PaywallTooltip from "./PaywallTooltip"

import { ROUTE_PATH } from "../../../data/configs/constants"

const ShowUpgradeOptions = ({
  plans,
  addOns,
  size = "default",
  title = "Get access to this feature",
  message = "Please subscribe to a plan or purchase addons from the list given below to unlock feature.",
  btnData = {},
}) => {
  const {token: themeToken} = theme.useToken()
  const [openModal, setOpenModal] = useState(false)

  const handleClick = () => {
    setOpenModal(true)
  }
  const handleModalClose = () => {
    setOpenModal(false)
  }

  if (size === "default")
    return (
      <RenderPayWall
        plans={plans}
        addOns={addOns}
        title={title}
        message={message}
      />
    )
  else
    return (
      <div style={{ display: "flex", gap: "8px" }}>
        <Modal
          open={openModal}
          onCancel={handleModalClose}
          footer={null}
          centered
          style={{
            maxWidth: 600,
            width: "100%",
            maxHeight: "50%",
            margin: "auto",
            overflow: "auto",
          }}
        >
          <Card style={{ border: "none" }}>
            <RenderPayWall
              plans={plans}
              addOns={addOns}
              title={title}
              message={message}
            />
          </Card>
        </Modal>
        <PaywallTooltip title={title} arrow>
          {size === "icon" ? (
            <Button
              type="text"
              icon={<i className="ri-lock-2-line" />}
              onClick={handleClick}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                color: themeToken.colorWhite,
              }}
            />
          ) : (
            <Button
              type="primary"
              icon={<i className="ri-lock-2-line" />}
              onClick={handleClick}
              {...btnData.props}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                color: themeToken.colorWhite,
              }}
            >
              {btnData.label || "Unlock Feature"}
            </Button>
          )}
        </PaywallTooltip>
      </div>
    )
}

const RenderPayWall = ({ plans, addOns, message, title }) => {
  const { token } = theme.useToken()
  const navigate = useNavigate()
  const handlePlansClick = () => {
    navigate(ROUTE_PATH.MAIN_PRICING)
  }
  const handleAddonClicked = () => {
    navigate(ROUTE_PATH.MAIN_PRICING + "#addon")
  }

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "700px",
        textAlign: "center",
        borderRadius: "12px",
      }}
    >
      <Typography.Title
        level={4}
        style={{ color: token.colorText, marginBottom: "8px" }}
      >
        {title}
      </Typography.Title>
      <Typography.Text
        type="secondary"
        style={{
          display: "block",
          marginBottom: "16px",
          color: token.colorTextSecondary,
        }}
      >
        {message}
      </Typography.Text>
      <Row gutter={[16, 16]} justify="center">
        <RenderGridItem
          key={1}
          item={plans}
          handleClick={handlePlansClick}
          title="Plan Subscription"
          btnText="BUY PLAN"
          type="plan"
        />
        <RenderGridItem
          key={2}
          item={addOns}
          handleClick={handleAddonClicked}
          title="Purchase Addons"
          btnText="BUY ADDON"
          type="addOns"
        />
      </Row>
    </div>
  )
}

const RenderGridItem = ({ item, handleClick, title, btnText, type }) => {
  const { token } = theme.useToken()

  if (!item?.length) return null
  return (
    <Col xs={24} sm={12} style={{ paddingLeft: "12px", paddingRight: "12px" }}>
      <Card
        bordered={false}
        style={{
          height: "100%",
          backgroundColor: token.colorBgContainer,
          color: token.colorText,
          borderRadius: "12px",
          padding: "16px",
          boxShadow: `0px 4px 10px ${token.colorBorder}`,
        }}
        bodyStyle={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: 0,
        }}
      >
        <div
          style={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            marginBottom: "14px",
          }}
        >
          <Typography.Text
            strong
            style={{
              display: "block",
              textAlign: "center",
              fontSize: "18px",
              color: token.colorText,
            }}
          >
            {title}
          </Typography.Text>
          <Divider
            style={{ background: token.colorBorderSecondary, margin: "12px 0" }}
          />
          <List
            dataSource={item}
            renderItem={(plan) => (
              <List.Item
                onClick={handleClick}
                style={{
                  display: "flex",
                  gap: "8px",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  background: "transparent",
                  border: "none",
                  padding: "6px 0",
                }}
              >
                {type === "plan" ? (
                  <i
                    className="ri-vip-crown-2-line"
                    style={{ color: token.colorPrimary, fontSize: "16px" }}
                  />
                ) : (
                  <i
                    className="ri-apps-2-add-line"
                    style={{ color: token.colorPrimary, fontSize: "16px" }}
                  />
                )}
                <Typography.Text
                  style={{ color: token.colorText, fontSize: "16px" }}
                >
                  {plan}
                </Typography.Text>
              </List.Item>
            )}
          />
        </div>
        <div>
          <Button
            type="primary"
            block
            size="large"
            onClick={handleClick}
            style={{
              backgroundColor: token.colorPrimary,
              borderRadius: "8px",
              fontWeight: "bold",
              color: token.colorWhite
            }}
          >
            {btnText}
          </Button>
        </div>
      </Card>
    </Col>
  )
}

export default ShowUpgradeOptions
